"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var defaults = {
  id: null,
  name: null,
  dueDays: 0
};

var AccountingTerms =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(AccountingTerms, _Record);

  function AccountingTerms() {
    (0, _classCallCheck2.default)(this, AccountingTerms);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AccountingTerms).apply(this, arguments));
  }

  return AccountingTerms;
}((0, _immutable.Record)(defaults));

var _default = AccountingTerms;
exports.default = _default;
module.exports = exports.default;